export enum AuditEntityTypeName {
  ContractEntity = 'ContractEntity',
  ModemEntity = 'ModemEntity',
  CommercialMeteringPointEntity = 'CommercialMeteringPointEntity',
  CommercialMeteringPointOwnershipEntity = 'CommercialMeteringPointOwnershipEntity',
  GasPipelineSectionEntity = 'GasPipelineSectionEntity',
  ActBalanceOwnershipEntity = 'ActBalanceOwnershipEntity',
  ViolationActEntity = 'ViolationActEntity',
  MeteringDeviceEntity = 'MeteringDeviceEntity',
  MeteringPointEntity = 'MeteringPointEntity',
  SealEntity = 'SealEntity',
  GasConsumingEquipmentEntity = 'GasConsumingEquipmentEntity',
  MeteringPointActEntity = 'MeteringPointActEntity',
  CounterpartyEntity = 'CounterpartyEntity',
  ContactPersonEntity = 'ContactPersonEntity',
  OperatingGasRouteEntity = 'OperatingGasRouteEntity',
  SectorBridgeEntity = 'SectorBridgeEntity',
  SectorBridgeActEntity = 'SectorBridgeActEntity',
  ConsumersInformationEntity = 'ConsumersInformationEntity',
  GasRoutePhysicoChemicalIndicatorEntity = 'GasRoutePhysicoChemicalIndicatorEntity',
  CommercialMeteringPointExpenseEntity = 'CommercialMeteringPointExpenseEntity',
  GasThreadOperationalIncomeEntity = 'GasThreadOperationalIncomeEntity',
  ActualIncomeDocumentEntity = 'ActualIncomeDocumentEntity',
  DailyExpenseEntity = 'DailyExpenseEntity',
  MeteringPointOperationalIncomeEntity = 'MeteringPointOperationalIncomeEntity',
  MeteringPointActualIncomeEntity = 'MeteringPointActualIncomeEntity',
  MeteringPointTechnicalCalculationEntity = 'MeteringPointTechnicalCalculationEntity',
  MeteringPointAdjustmentEntity = 'MeteringPointAdjustmentEntity',
  MeteringPointOwnDemandEntity = 'MeteringPointOwnDemandEntity',
  MeteringDeviceActualIncomeIndicatorEntity = 'MeteringDeviceActualIncomeIndicatorEntity',
}
